import { createSlice } from "@reduxjs/toolkit";
import { routerChangeAction } from "const";

const sections = [
  { name: 'primary', pathRegex: new RegExp('/primary/?') },
  { name: 'secondary', pathRegex: new RegExp('/secondary/?') },
  { name: "portfolio", pathRegex: new RegExp("/ultra-high/portfolio") },
  {
    name: "investment",
    pathRegex: [new RegExp("/primary/?"), new RegExp("/secondary/?")],
  },
];
const initialState = {
  currentMenuSelected: null,
};

const slice = createSlice({
  initialState,
  name: "navigation",
  reducers: {
    selectNavigationMenu: (state, action) => {
      state.currentMenuSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      let currentMenuSelected = null;
      for (const section of sections) {
        let pathRegex = section.pathRegex;
        if (!Array.isArray(pathRegex)) {
          pathRegex = [pathRegex];
        }
        const match = pathRegex.some((regex) =>
          regex.test(payload.location.pathname)
        );
        if (match) {
          currentMenuSelected = section.name;
          break;
        }
      }
      state.currentMenuSelected = currentMenuSelected;
    });
  },
});

export const { selectNavigationMenu } = slice.actions;

export default slice;
